import React, { useEffect } from "react";
import { getImageUrl } from "../../helper/constants";

const ContactCard = ({ data, icons }) => {
    return (
        <>
            <ul className="contact-list">
                {data?.length > 0 ? (
                    data?.map((detail, index) => {
                        return (
                            <div className="contact-card" key={index}>
                                <div className='contact-card_image'>
                                    <img src={
                                        icons?.[
                                            detail?.type
                                        ]
                                            ? getImageUrl(
                                                icons?.[
                                                detail?.type
                                                ]
                                            )
                                            : ""
                                    } />
                                </div>


                                <div className='contact-card_text'>
                                    <div className='contact-card_name'>    {detail?.name},{"  "}

                                        <span>{detail?.radius}</span>
                                    </div>
                                    <div className="contact-card_numbers" >
                                        {detail?.contacts?.map((c, index) => (
                                            <span key={index} className="contact-card_number">
                                                {c}
                                                {index !== detail.contacts.length - 1 && " | "}
                                            </span>
                                        ))}</div>

                                </div>


                            </div>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan="5" className="text_center">
                            No data found
                        </td>
                    </tr>
                )}
            </ul>
        </>
    );
};

export default ContactCard;
